import { TFunction } from 'i18next';
import * as Yup from 'yup';
import { INVALID_FIELDS, YupNumber, YupString } from './general';

export const existingExtractionIdSchema = Yup.object().shape({
  id: Yup.string().required(INVALID_FIELDS.REQUIRED),
});

export const scanKitExtraction = Yup.object().shape({
  serial: Yup.string().required('Required'),
});

export const ExtractionSchema = Yup.object().shape({
  dateOf: Yup.date().required(INVALID_FIELDS.REQUIRED),
  technicians: Yup.array().of(
    Yup.string().required('You must select at least 1 Technician'),
  ),
  sampleType: YupString,
});

export const OrgExtractionSchema = ExtractionSchema.shape({
  tenantId: YupString,
});

export const ExistingExtractionSchema = Yup.object().shape({
  existingExtraction: Yup.string().required(INVALID_FIELDS.REQUIRED),
});
export const currentBatchExtractionSchema = (
  t: TFunction<'translation', undefined, 'translation'>,
) =>
  Yup.object().shape({
    volume: Yup.string()
      .required(INVALID_FIELDS.REQUIRED)
      .test(
        'Not valid',
        t(INVALID_FIELDS.MIN_NUMBER, { number: 1 }) as string,
        value => {
          return Number(value) >= 1;
        },
      ),
  });

const concentrationSchema = Yup.object().shape({
  concentration: YupNumber,
  finalConcentration: YupNumber,
});
export const updateExtractionSchema = Yup.array().of(
  Yup.object().shape({
    concentration: concentrationSchema,
  }),
);
